import { Component } from 'react';
import { Container } from 'react-bootstrap';
import PageTitle from '../../common/page-title';
import Carousel from './carousel';

class AdminHomePageMenu extends Component {
  constructor(props) {
    super(props);

    this.type = this.props.match.params.type;
  }

  render() {
    const { type } = this;

    return (
      <Container fluid className="homepagemenu">
        <PageTitle>
          Homepage Carousel
        </PageTitle>
        <Carousel type={type}/>
      </Container>
    );
  }
}

export default AdminHomePageMenu;
